// Aggiunge on:click="cart-drawer-component/close" a tutti gli elementi .fi-trigger-button
(function () {
  const ATTR_NAME = 'on:click';
  const ATTR_VALUE = 'cart-drawer-component/close';
  const TARGET_SELECTOR = '.fi-trigger-button';

  function addAttrTo(el) {
    if (!el || el.nodeType !== 1) return;
    // se già c'è un attributo on:click non lo sovrascriviamo
    const existing = el.getAttribute(ATTR_NAME);
    if (existing && existing.trim().length) {
      // se vuoi concatenare invece di lasciare stare: 
      // el.setAttribute(ATTR_NAME, existing + ';' + ATTR_VALUE);
      return;
    }
    el.setAttribute(ATTR_NAME, ATTR_VALUE);
  }

  // Applica a tutti quelli già presenti nel DOM
  function applyToAllExisting() {
    const list = document.querySelectorAll(TARGET_SELECTOR);
    list.forEach(addAttrTo);
  }

  // Osserva aggiunte future al DOM e applica l'attributo a nuovi .fi-trigger-button
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      // nodi aggiunti: controlliamo direttamente e anche eventuali discendenti
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;
          // se il nodo stesso è un trigger
          if (node.matches && node.matches(TARGET_SELECTOR)) addAttrTo(node);
          // se dentro il nodo ci sono trigger
          const descendants = node.querySelectorAll && node.querySelectorAll(TARGET_SELECTOR);
          if (descendants && descendants.length) {
            descendants.forEach(addAttrTo);
          }
        });
      }
    }
  });

  function start() {
    applyToAllExisting();

    // osserva l'intero document body per future aggiunte
    if (window.MutationObserver && document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }

    // opzionale: se vuoi fermare l'observer dopo N secondi (riduce overhead),
    // puoi decommentare la riga sotto (es. 30s).
    // setTimeout(() => observer.disconnect(), 30000);
  }

  // Se il DOM è già pronto
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start, { once: true });
    // fallback: se DOMContentLoaded non arriva (strani casi), forza dopo 3s
    setTimeout(() => {
      if (document.readyState !== 'complete' && document.readyState !== 'interactive') {
        start();
      }
    }, 3000);
  }
})();
